import { render, staticRenderFns } from "./QuestionEditor.vue?vue&type=template&id=d48938d6&scoped=true"
import script from "./QuestionEditor.vue?vue&type=script&lang=js"
export * from "./QuestionEditor.vue?vue&type=script&lang=js"
import style0 from "./QuestionEditor.vue?vue&type=style&index=0&id=d48938d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48938d6",
  null
  
)

export default component.exports